import {
  FinancialSituation,
  ServerFinancialSituationFetch,
  ClearFinancialSituationErrorAction,
  CreateFinancialSituationAction,
  CreateFinancialSituationFailAction,
  CreateFinancialSituationSuccessAction,
  DeleteFinancialSituationAction,
  DeleteFinancialSituationFailAction,
  DeleteFinancialSituationSuccessAction,
  FetchFinancialSituationsAction,
  FetchFinancialSituationsFailAction,
  FetchFinancialSituationsSuccessAction,
  UpdateFinancialSituationAction,
  UpdateFinancialSituationFailAction,
  UpdateFinancialSituationSuccessAction,
  UpsertFinancialSituationsAction,
  UpsertFinancialSituationsFailAction,
  UpsertFinancialSituationsSuccessAction,
} from '@funnels/types';
import { REDUX_STORE } from '@funnels/constants';

export function clearFinancialSituationError(): ClearFinancialSituationErrorAction {
  return { type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.CLEAR_FINANCIAL_SITUATION_ERROR };
}

export function createFinancialSituation(
  applicationId: string,
  financialSituation: FinancialSituation
): CreateFinancialSituationAction {
  return {
    type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.CREATE_FINANCIAL_SITUATION,
    applicationId,
    financialSituation,
  };
}

export function createFinancialSituationFail(
  clientId: string,
  message: string = 'Unknown error'
): CreateFinancialSituationFailAction {
  return { type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.CREATE_FINANCIAL_SITUATION_FAIL, clientId, message };
}

export function createFinancialSituationSuccess(clientId: string, id: string): CreateFinancialSituationSuccessAction {
  return { type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.CREATE_FINANCIAL_SITUATION_SUCCESS, clientId, id };
}

export function deleteFinancialSituation(
  applicationId: string,
  clientId: string,
  applicantId: string
): DeleteFinancialSituationAction {
  return {
    type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.DELETE_FINANCIAL_SITUATION,
    applicationId,
    clientId,
    applicantId,
  };
}

export function deleteFinancialSituationFail(
  clientId: string,
  message: string = 'Unknown error'
): DeleteFinancialSituationFailAction {
  return { type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.DELETE_FINANCIAL_SITUATION_FAIL, clientId, message };
}

export function deleteFinancialSituationSuccess(): DeleteFinancialSituationSuccessAction {
  return { type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.DELETE_FINANCIAL_SITUATION_SUCCESS };
}

export function fetchFinancialSituations(applicationId: string, applicantId?: string): FetchFinancialSituationsAction {
  return { type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.FETCH_FINANCIAL_SITUATIONS, applicationId, applicantId };
}

export function fetchFinancialSituationsFail(message: string = 'Unknown error'): FetchFinancialSituationsFailAction {
  return { type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.FETCH_FINANCIAL_SITUATIONS_FAIL, message };
}

export function fetchFinancialSituationsSuccess(
  financialSituations: ServerFinancialSituationFetch[]
): FetchFinancialSituationsSuccessAction {
  return {
    type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.FETCH_FINANCIAL_SITUATIONS_SUCCESS,
    financialSituations,
  };
}

export function updateFinancialSituation(
  applicationId: string,
  financialSituation: FinancialSituation
): UpdateFinancialSituationAction {
  return {
    type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.UPDATE_FINANCIAL_SITUATION,
    applicationId,
    financialSituation,
  };
}

export function updateFinancialSituationFail(
  clientId: string,
  message: string = 'Unknown error'
): UpdateFinancialSituationFailAction {
  return { type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.UPDATE_FINANCIAL_SITUATION_FAIL, clientId, message };
}

export function updateFinancialSituationSuccess(): UpdateFinancialSituationSuccessAction {
  return { type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.UPDATE_FINANCIAL_SITUATION_SUCCESS };
}

export function upsertFinancialSituations(
  applicationId: string,
  financialSituations: FinancialSituation[]
): UpsertFinancialSituationsAction {
  return {
    type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.UPSERT_FINANCIAL_SITUATIONS,
    applicationId,
    financialSituations,
  };
}

export function upsertFinancialSituationsFail(message: string): UpsertFinancialSituationsFailAction {
  return { type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.UPSERT_FINANCIAL_SITUATIONS_FAIL, message };
}

export function upsertFinancialSituationsSuccess(): UpsertFinancialSituationsSuccessAction {
  return { type: REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.UPSERT_FINANCIAL_SITUATIONS_SUCCESS };
}
